module.exports = __webpack_public_path__ + "img/customer_empty_icon.02adbe64.png";